__turbopack_context__.v({
  "accountButton": "DiscoveryHeaderNav-module__kEZeXq__accountButton",
  "accountDesktop": "DiscoveryHeaderNav-module__kEZeXq__accountDesktop",
  "accountMenu": "DiscoveryHeaderNav-module__kEZeXq__accountMenu",
  "accountMenuItem": "DiscoveryHeaderNav-module__kEZeXq__accountMenuItem",
  "accountName": "DiscoveryHeaderNav-module__kEZeXq__accountName",
  "actions": "DiscoveryHeaderNav-module__kEZeXq__actions",
  "bar": "DiscoveryHeaderNav-module__kEZeXq__bar",
  "chevronOpen": "DiscoveryHeaderNav-module__kEZeXq__chevronOpen",
  "desktopGuestLinks": "DiscoveryHeaderNav-module__kEZeXq__desktopGuestLinks",
  "desktopNav": "DiscoveryHeaderNav-module__kEZeXq__desktopNav",
  "discoveryChromePulse": "DiscoveryHeaderNav-module__kEZeXq__discoveryChromePulse",
  "dropdown": "DiscoveryHeaderNav-module__kEZeXq__dropdown",
  "dropdownDescription": "DiscoveryHeaderNav-module__kEZeXq__dropdownDescription",
  "dropdownLabel": "DiscoveryHeaderNav-module__kEZeXq__dropdownLabel",
  "dropdownLink": "DiscoveryHeaderNav-module__kEZeXq__dropdownLink",
  "dropdownList": "DiscoveryHeaderNav-module__kEZeXq__dropdownList",
  "dropdownText": "DiscoveryHeaderNav-module__kEZeXq__dropdownText",
  "header": "DiscoveryHeaderNav-module__kEZeXq__header",
  "iconImage": "DiscoveryHeaderNav-module__kEZeXq__iconImage",
  "iconTile": "DiscoveryHeaderNav-module__kEZeXq__iconTile",
  "initials": "DiscoveryHeaderNav-module__kEZeXq__initials",
  "loading": "DiscoveryHeaderNav-module__kEZeXq__loading",
  "logo": "DiscoveryHeaderNav-module__kEZeXq__logo",
  "logoLink": "DiscoveryHeaderNav-module__kEZeXq__logoLink",
  "menuIcon": "DiscoveryHeaderNav-module__kEZeXq__menuIcon",
  "menuIconImage": "DiscoveryHeaderNav-module__kEZeXq__menuIconImage",
  "mobileAccountLink": "DiscoveryHeaderNav-module__kEZeXq__mobileAccountLink",
  "mobileActions": "DiscoveryHeaderNav-module__kEZeXq__mobileActions",
  "mobileDirectLink": "DiscoveryHeaderNav-module__kEZeXq__mobileDirectLink",
  "mobileGuestLinks": "DiscoveryHeaderNav-module__kEZeXq__mobileGuestLinks",
  "mobileItem": "DiscoveryHeaderNav-module__kEZeXq__mobileItem",
  "mobileItemButton": "DiscoveryHeaderNav-module__kEZeXq__mobileItemButton",
  "mobileList": "DiscoveryHeaderNav-module__kEZeXq__mobileList",
  "mobileMenuLink": "DiscoveryHeaderNav-module__kEZeXq__mobileMenuLink",
  "mobileNav": "DiscoveryHeaderNav-module__kEZeXq__mobileNav",
  "mobilePanel": "DiscoveryHeaderNav-module__kEZeXq__mobilePanel",
  "mobileSubLink": "DiscoveryHeaderNav-module__kEZeXq__mobileSubLink",
  "mobileSubList": "DiscoveryHeaderNav-module__kEZeXq__mobileSubList",
  "mobileToggle": "DiscoveryHeaderNav-module__kEZeXq__mobileToggle",
  "panelGroupLabel": "DiscoveryHeaderNav-module__kEZeXq__panelGroupLabel",
  "parentChip": "DiscoveryHeaderNav-module__kEZeXq__parentChip",
  "parentChipButton": "DiscoveryHeaderNav-module__kEZeXq__parentChipButton",
  "signIn": "DiscoveryHeaderNav-module__kEZeXq__signIn",
  "signUp": "DiscoveryHeaderNav-module__kEZeXq__signUp",
  "skeletonBone": "DiscoveryHeaderNav-module__kEZeXq__skeletonBone",
  "skeletonTab": "DiscoveryHeaderNav-module__kEZeXq__skeletonTab",
  "skeletonTopLink": "DiscoveryHeaderNav-module__kEZeXq__skeletonTopLink",
  "tab": "DiscoveryHeaderNav-module__kEZeXq__tab",
  "tabActive": "DiscoveryHeaderNav-module__kEZeXq__tabActive",
  "tabItem": "DiscoveryHeaderNav-module__kEZeXq__tabItem",
  "tabList": "DiscoveryHeaderNav-module__kEZeXq__tabList",
  "topLink": "DiscoveryHeaderNav-module__kEZeXq__topLink",
  "topLinkBar": "DiscoveryHeaderNav-module__kEZeXq__topLinkBar",
  "topLinkCurrent": "DiscoveryHeaderNav-module__kEZeXq__topLinkCurrent",
  "topLinkIcon": "DiscoveryHeaderNav-module__kEZeXq__topLinkIcon",
  "topLinkLabel": "DiscoveryHeaderNav-module__kEZeXq__topLinkLabel",
  "topLinkList": "DiscoveryHeaderNav-module__kEZeXq__topLinkList",
  "topLinkWithIcon": "DiscoveryHeaderNav-module__kEZeXq__topLinkWithIcon",
});
